import { Channels } from "../../shared/store-mocks/channels.store"
import { MessageLogsResponseType } from "../log-analyser.models"

export const mapResponseTypeToVisibleColumns = (responseType: MessageLogsResponseType, appsNameVisibility:boolean): any  => {
    let cols = []
    if (responseType === MessageLogsResponseType.Whatsapp) {
      cols.push('sender')
      cols.push('product')
      cols.push('recipient')
      cols.push('sentAt')
      cols.push('status')
      cols.push('action')
    } 
    
    if (responseType === MessageLogsResponseType.Sms) {
      
      cols.push('sender')
      cols.push('recipient')
      cols.push('date')
      cols.push('status')

      if(appsNameVisibility){
        cols.push('applicationName')
      }
      
      cols.push('action')
    }

    return cols
}
